import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js'
import download from 'downloadjs';
import Loader from './../shared/loader'
import Pagination from './../shared/pagination'
import csvHelper from '../reports/importjsontocsv';
import Vue from "vue";
import JsonExcel from "vue-json-excel";
import JSZip from "jszip";

import {
	BasicSelect
} from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
import Multiselect from 'vue-multiselect'
Vue.component("downloadExcel", JsonExcel);

export default {
	name: 'order',
	components: {
		Paginate,
		Pagination,
		JsonExcel,
		DatePicker,
		Loader,
		BasicSelect,
		Multiselect
	},
	data() {
		return {
			// currentPage: 0,
			mid: '',
			isLoadingforxls: false,
			csvFieldsForXls: {},
			listReportDataforxls: [],
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,
			fromDateFlt: '',
			// perPage: 10,
			// totalPage: 0,
			// pageNo: 0,
			orderStatus: '',
			isLoading: false,
			listClientData: [],
			listWarehouseData: [],
			totalrowsData: [],
			listOrderReportDataCsv: [],

			ClientErr: '',
			WarehouseErr: '',
			showSelectWarehouse: false,
			showSelectClient: false,
			showSelectMerchant: false,

			clientid: '',
			client: '',
			warehouseid: '',
			warehouse: '',

			//checkStatus: 0,
			searchchannel: '',
			formattedDate: '',
			ordersubtype: '',
			user_type: '',
			userid: '',
			show: false,
			download: true,
			dataFilter2: '',
			dataFilter: '',
			reportname: '',
			reportnameOutside: '',

			recordLimit: 0,
			limitExeed: false,
			listMerchantData: [],
			merchant: '',
			toDateFlt: '',
			currentDate: '',
			OrderId: '',
			ReturnstypeErr: '',
			FromdateErr: '',
			todateErr: '',
			listRecoReportData: [],
			listRecoReportDataCsv: [],
			returntypeshow: '',
			listReturnsStatus: [],
			returnstype: '',
			useremail: '',
		}
	},
	model: {
		totalqty: 0
	},
	computed: {},
	filters: {

		moment: function (date) {
			if (date != null)
				return moment(date).format('DD-MM-YYYY');
		},
		momentDateTime: function (date) {
			if (date != null)
				return moment(date).format('DD-MM-YYYY HH:mm:ss');
		}
	},
	mounted() {
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		var loginuserid = userdetail.userid;
		var loginuseremail = userdetail.email;
		this.useremail = userdetail.email;
		this.userid = userdetail.userid;
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		this.reportname = this.$t('recolinationReport.RecolinationReport')
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss')
		this.pageNo = 0;
		this.user_type = userdetail.utype;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				this.showSelectMerchant = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				this.showSelectWarehouse = true;
				this.showSelectMerchant = true;
				// this.getWarehouseList();
				if (userdetail.merchantid) {
					this.mid = userdetail.merchantid.toString()
					this.merchant = this.mid
					this.showSelectMerchant = false;
				}
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				this.showSelectMerchant = true;
				// this.getClientList();
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'))
				break
		}
		this.getRecordLimit();
		this.calldateFunction();
	}, // End computed
	filters: {
		moment: function (date) {
			if (date)
				return moment(date).format('DD-MM-YYYY HH:mm:ss');
			else {
				return '';
			}
		}
	},
	methods: {
		reset() {
			this.item = {}
			this.branditem = {}
		},
		onSelect(item) {
			this.item = item
			this.merchant = item.value;

		},
		onSelectBrand(item) {
			this.branditem = item
			this.brand = item.text;
		},
		calldateFunction() {
			this.currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');

			var dt = new Date(this.currentDate);
			dt.setDate(dt.getDate() - 6);
			this.toDateFlt = this.currentDate;
			this.fromDateFlt = dt;

		},



		getRecordLimit() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getRecordLimit',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data) {
						this.recordLimit = result.data.data;
					}
				}, error => {
					console.error(error)
				})
		},
		Choosetype() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getRecolinationListReportXLS(3)
			}
		},
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},

		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD');
		},

		export(data, filename, mime) {
			let blob = this.base64ToBlob(data, mime);
			download(blob, filename, mime);
		},

		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)));
			let bstr = atob(base64);
			let n = bstr.length;
			let u8arr = new Uint8ClampedArray(n);
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}
			return new Blob([u8arr], {
				type: mime
			})
		},
		// getClientList() {
		// 	this.pageNo = 0;
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');

		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },
		// getWarehouseList() {
		// 	this.pageNo = 0;

		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.pageNo = 0;
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },

		// clientSelected() {
		// 	if (this.clientid != this.client) {
		// 		this.clientid = this.client;
		// 		this.listMerchantData = [];
		// 		this.listBrandData = []
		// 		this.returnstype = ''
		// 		this.ordersubtype = ''
		// 		// this.listReturnsStatus=[];
		// 		this.merchant = '';
		// 		if (this.clientid)
		// 			if (this.user_type != 'warehouse_user') {
		// 				this.listWarehouseData = [];
		// 				this.getWarehouseList();
		// 				if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 					this.warehouse = this.warehouseid = '';
		// 				} else {
		// 					this.warehouse = '';
		// 				}
		// 			}
		// 	}

		// 	this.pageNo = this.totalPage = 0;
		// },



		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageNo = this.totalPage = 0;
		// 	if (this.user_type == 'client_user') {
		// 		//this.getMerchantList();
		// 	}
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },

		getRecolinationListSearch(csvCheck) {
			this.currentPage = 1;
			this.getRecolinationListReport(2);
		},

		getRecolinationListReport(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			// this.pageNo = this.totalPage = this.totalRows = 0;
			// this.listRecoReportData = []
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
			}
			if (csvCheck == 2) {
				this.limitExeed = false
			}
			// process.exit()
			if (this.clientid == '') {
				this.ClientErr = this.$t('common.clientError');
				this.pageNo = this.totalPage = 0;
				this.listRecoReportData = []
				return false;
			}
			if (localStorage.getItem("selectedWarehouse") == '') {
				this.WarehouseErr = this.$t('common.warehouseError');
				this.pageNo = this.totalPage = 0;
				this.listRecoReportData = []
				return false;
			}
			if (this.returnstype == '') {
				this.ReturnstypeErr = this.$t('returnReceiptReport.returnTypeError');
				return false;
			}
			// if (this.fromDateFlt == '' || this.fromDateFlt == null) {
			// 	this.FromdateErr = this.$t('returnReceiptReport.fromDateFlterError');
			// 	return false
			// }
			// if (this.toDateFlt == '' || this.toDateFlt == null) {
			// 	this.todateErr = this.$t('returnReceiptReport.ToDateFlterError');
			// 	return false
			// }

			var fromdate = '';
			var todate = '';
			var dataFilter = {};
			this.returntypeshow = this.returnstype
			if (this.fromDateFlt != null && this.fromDateFlt != "") {
				fromdate = `${this.dateFormat(this.fromDateFlt)} 00:00:00`;
			}
			if (this.toDateFlt != null && this.toDateFlt != "") {
				todate = `${this.dateFormat(this.toDateFlt)} 23:59:59`;
			}
			var months;
			var fromDate = new Date(this.fromDateFlt);
			var ToDate = new Date(this.toDateFlt);
			months = ToDate.getMonth() - fromDate.getMonth() + (12 * (ToDate.getFullYear() - fromDate.getFullYear()))

			// if (this.fromDateFlt != '' && this.fromDateFlt != null && this.toDateFlt != null && this.toDateFlt != '' && months > 3) {
			// 	this.$alertify.error(this.$t('common.dateError'));
			// 	this.pageNo = this.totalPage = 0;
			// 	this.totalRows = 0;
			// 	this.listRecoReportData = [];
			// 	return false;
			// }

			this.isLoading = true;
			this.input = ({
				"returntype": this.returnstype,
				"status": "rackin"
				// fields:[]
				// "csvData": csvCheck
			});
			if (csvCheck == 1) {
				this.input.offset = 0
			} else {
				this.input.offset = (this.currentPage - 1) * 10
				this.input.limit = this.pageLimit
			}
			if (fromdate)
				this.input.rackinfromdate = fromdate
			if (todate)
				this.input.rackintodate = todate
			if (this.OrderId)
				this.input.orderids = this.OrderId

			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			dataFilter.clientid=this.clientid,
			dataFilter.warehouseid= this.warehouseid,

			axios({
				method: 'GET',
				'url': `${apiUrl.api_url}returns-reco`,
				'params': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
					'xbclientid': this.clientid,
					'xbwarehouseid': this.warehouseid,
				}
			})
				.then(result => {
					this.isLoading = false;
					if (csvCheck == 1) {
						if (result.data.data.length > 0) {
							this.csvFields = {
								'orderid': this.$t('common.orderID'),
								'rackindoneby': this.$t('removeHold.putawayDoneBy'),

								'saleschannel': this.$t('common.salesChannel'),
								'shipmentid': this.$t('unicommerce.invoiceError.uniwareShipmentID'),
								'clientproductid': this.$t('common.clientProductId'),
								'eancode': this.$t('common.eanCode'),
								'returntype': this.$t('returnReceiptReport.returnsType'),
								'uniwarereturntype': this.$t('recolinationReport.UniwareReturnType'),
								'code': this.$t('recolinationReport.UniwareOrderCode'),
								'uniwarereturnstatus': this.$t('recolinationReport.UniwareReturnsStatus'),
								'noofretries': this.$t('recolinationReport.NumberOfRetries'),
								'lastretry': this.$t('recolinationReport.LastRetryDate'),
								'uniwarereturnawbno': this.$t('common.awbNo'),
							};
							if (this.returnstype == 'rto') {

								this.csvFields['rackindatetime'] = this.$t('removeHold.putawayDate')
								this.csvFields['transporter'] = this.$t('ShippingDetails.transporter')
								this.csvFields['awbno'] = this.$t('createsr.reverseAWB')
								this.csvFields['rtoerrormessage'] = this.$t('recolinationReport.UniwareError')
								this.csvFields['rtolasterrortime'] = this.$t('unicommerce.invoiceError.lastErorDateandTime')
							} else {
								this.csvFields['rackindate'] = this.$t('removeHold.putawayDate')
								this.csvFields['couriercompany'] = this.$t('ShippingDetails.transporter')
								this.csvFields['awbnumber'] = this.$t('createsr.reverseAWB')
								this.csvFields['srerrormessage'] = this.$t('recolinationReport.UniwareError')
								this.csvFields['srlasterrortime'] = this.$t('unicommerce.invoiceError.lastErorDateandTime')
							}
							var dateFilter = [];
							var skipFilter = ['awbno', 'productid', 'iscntitem', 'ordercode','isreturnclose'];
							this.listRecoReportDataCsv = result.data.data;

							csvHelper.data.jsonToCSV(this.reportname, this.listRecoReportDataCsv, this.csvFields, dateFilter, skipFilter,dataFilter);

						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);

							}
						}
					}
					else {
						if (result.data.errorCode == -1) {
							this.$alertify.error(result.data.msg);
							this.show = false;
							this.download = true;
							this.totalRows = 0;
							this.pageNo = this.totalPage = 0;
							this.listRecoReportData = []

						} else {
							this.listRecoReportData = result.data.data;
							this.totalRows = Number(result.data.summary.totalCount);
							if (this.totalRows > 0) {
								if (this.totalRows <= this.pageLimit) {
									this.totalPage = 1;
								} else {
									this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
								}
							} else {
								this.totalPage = 0;
							}
						}
					}

				}).catch((error) => {
					this.isLoading = false;
					console.log(error);
				})

		},

		getRecolinationListReportXLS(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
			}
			if (csvCheck == 2) {
				this.limitExeed = false
			}
			if (this.client == '') {
				this.ClientErr = this.$t('common.clientError');
				this.pageNo = this.totalPage = 0;
				this.listRecoReportData = []
				return false;
			}
			if (localStorage.getItem("selectedWarehouse")  == '') {
				this.WarehouseErr = this.$t('common.warehouseError');
				this.pageNo = this.totalPage = 0;
				this.listRecoReportData = []
				return false;
			}
			if (this.returnstype == '') {
				this.ReturnstypeErr = this.$t('returnReceiptReport.returnTypeError');
				return false;
			}
			//if (this.fromDateFlt == '' || this.fromDateFlt == null) {
			// 	this.FromdateErr = this.$t('returnReceiptReport.fromDateFlterError');
			// 	return false
			// }
			// if (this.toDateFlt == '' || this.toDateFlt == null) {
			// 	this.todateErr = this.$t('returnReceiptReport.ToDateFlterError');
			// 	return false
			// }
			// if (action == 1)
			//   this.pageNo = this.totalPage = 0;
			var fromdate = '';
			var todate = '';
			var value = '';
			var str = ''

			var dataFilter = {};

			if (this.fromDateFlt != null && this.fromDateFlt != "") {
				fromdate = this.dateFormat(this.fromDateFlt) + " 00:00:00";
			}
			if (this.toDateFlt != null && this.toDateFlt != "") {
				todate = this.dateFormat(this.toDateFlt) + " 23:59:59";
			}


			this.isLoading = true;

			// this.input = ({
			// 	"clientid": this.clientid,
			// 	"warehouseid": this.warehouseid,
			// 	"returnsType": this.returnstype,
			// 	"fromdate": fromdate,
			// 	"todate": todate,
			// 	"orderid": this.OrderId,
			// });
			this.input = ({
				"returntype": this.returnstype,

				"offset": 0,
				"status": "rackin"
				// fields:[]
				// "csvData": csvCheck
			});
			if (fromdate)
				this.input.rackinfromdate = fromdate
			if (todate)
				this.input.rackintodate = todate
			if (this.OrderId)
				this.input.orderids = this.OrderId
			this.input.clientid=this.clientid
			this.input.warehouseid= this.warehouseid,
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);
				}
			})
			delete this.input.clientid
	     	delete	this.input.warehouseid
			axios({
				method: 'GET',
				'url': `${apiUrl.api_url}returns-reco`,
				'params': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
					'xbclientid':this.client,
					'xbwarehouseid':localStorage.getItem("selectedWarehouse"),
				}
			})
				.then(result => {
					this.isLoading = false;
					if (csvCheck == 3) {
						if (result.data.data.length > 0) {
							var skipFilter = [];
							this.listReportDataforxls = [];
							this.csvFieldsForXls[this.$t('returnReceiptReport.returnsType')] = 'returntype';
							this.csvFieldsForXls[this.$t('common.salesChannel')] = 'saleschannel';
							this.csvFieldsForXls[this.$t('ShippingDetails.transporter')] = this.returnstype == 'rto' ? 'transporter' : 'couriercompany';
							this.csvFieldsForXls[this.$t('removeHold.putawayDoneBy')] = 'rackindoneby';
							// this.csvFieldsForXls[this.$t('removeHold.putawayDate')]='rackindate';
							this.csvFieldsForXls[this.$t('common.orderID')] = 'orderid';
							this.csvFieldsForXls[this.$t('createsr.reverseAWB')] = this.returnstype == 'rto' ? 'awbno' : 'awbnumber';
							this.csvFieldsForXls[this.$t('common.clientProductId')] = 'clientproductid';
							this.csvFieldsForXls[this.$t('common.eanCode')] = 'eancode';
							this.csvFieldsForXls[this.$t('removeHold.putawayDate')] = 'rackindatetime';
							this.csvFieldsForXls[this.$t('recolinationReport.UniwareReturnType')] = 'uniwarereturntype';
							this.csvFieldsForXls[this.$t('recolinationReport.UniwareOrderCode')] = 'ordercode';
							this.csvFieldsForXls[this.$t('unicommerce.invoiceError.uniwareShipmentID')] = 'shipmentid';
							this.csvFieldsForXls[this.$t('recolinationReport.UniwareReturnsStatus')] = 'uniwarereturnstatus';
							this.csvFieldsForXls[this.$t('recolinationReport.UniwareError')] = this.returnstype == 'rto' ? 'rtoerrormessage' : 'srerrormessage';
							this.csvFieldsForXls[this.$t('recolinationReport.NumberOfRetries')] = 'noofretries';
							this.csvFieldsForXls[this.$t('recolinationReport.LastRetryDate')] = 'lastretry';
							this.csvFieldsForXls[this.$t('common.awbNo')] = 'uniwarereturnawbno';
							this.csvFieldsForXls[this.$t('unicommerce.invoiceError.lastErorDateandTime')] = this.returnstype == 'rto' ? 'rtolasterrortime' : 'srlasterrortime';
							this.listReportDataforxls = result.data.data;
						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}
					}
				}, error => {
					console.error(error)
					this.isLoading = false;
				});
		},

		async recoRetryReturn(data) {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			var awbno = '';
			if (this.returnstype == 'rto') {
				awbno = data.awbno;
			} else {
				awbno = data.awbnumber;
			}

			this.input = ({
					orderid: data.orderid,
					warehouseid:localStorage.getItem("selectedWarehouse"),
					clientid: this.client,
				})
			  this.isLoading = true;
			  axios({
				method: 'POST',
				'url': apiUrl.api_url + 'closeReturnsInUniware',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					if (result.data.data.status == true) {
						this.$alertify.success(result.data.data.msg)
						this.getRecolinationListReport()
						this.isLoading = false;
					} else {
						this.$alertify.error(result.data.data.msg)
						this.getRecolinationListReport()
						this.isLoading = false;
					}
				}, error => {
					this.$alertify.error(error)
					console.error(error)
					this.isLoading = false;

				})
		},
		onPageChange(page) {
			this.currentPage = page;
			this.getRecolinationListReport()

		},

		resetOffset() {
			this.currentPage = 1;
		},

		resetRecolinationSerach() {
			this.returnstype = ''
			this.ClientErr = ''
			this.WarehouseErr = '',
				this.ReturnstypeErr = '',
				this.FromdateErr = ''
			this.todateErr = '',
				this.show = false;
			this.download = true;
			this.totalRows = 0;
			this.pageNo = this.totalPage = 0;
			this.listRecoReportData = []
			if (this.OrderId != '' && this.OrderId != null) {
				document.getElementById("OrderId").value = "";
			}

			this.OrderId = '';
			this.fromDateFlt = '';
			this.toDateFlt = '';

			//this.eancode = ''

			if (this.user_type == 'warehouse_user')
				this.clientname = '';
			else if (this.user_type == 'client_user')
				this.warehouse = '';
			else {
				this.clientmname = '';
				this.warehouse = '';
			}
		},

		//validate all form fields on onsubmit()
		onSubmit: function () {
			this.$validator.validateAll().then(() => { }).catch(() => { });
		},
	} // end methods

}



// WEBPACK FOOTER //
// ./src/views/components/reconciliationreport/reconciliationreport.component.js